import { Component, OnInit, Inject, Input } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { MDCDialog } from '@material/dialog';
import { Subscription } from 'rxjs'
import { CacheService } from '../services/cache.service';
import { ConstantsService } from "../services/constants.service";
@Component({
  selector: 'app-windowpopup',
  templateUrl: './windowpopup.component.html',
  styleUrls: ['./windowpopup.component.scss']
})
export class WindowpopupComponent implements OnInit {
  private dialog = null;
  public bookmark = false;
  public location = false;
  ClickEventSubscription: Subscription;
  public loggedin: boolean;
  constructor(@Inject(DOCUMENT)
  private document: Document,
    private cache: CacheService,
    public constants: ConstantsService,) {
    this.ClickEventSubscription = this.cache.getEvent().subscribe(() => {
      this.open();
    })
  }
  ngOnInit(): void {
  }
  open() {
    this.dialog = new MDCDialog(this.document.querySelector('#window-pop-up'));
    this.dialog.open();
  }
  close() {
    this.dialog.close();
  }
}
